import { IComponentOptions, IController, IFormController } from 'angular';
import { IDynamicInput } from '../../../core/interfaces';
import { $Event } from '../../../helpers';
import { ISocialNetworks } from '../../../core/entities/profile';
import { ToastrService } from '../../../core/services/toastr/toastr.service';
import './social-form.component.scss';

class SocialFormController implements IController {
  static $inject = [
    'ToastrService'
  ];
  onSave: ( $event: $Event<ISocialNetworks> ) => void;
  socials: { [ key: string ]: string } = {};
  socialForm: IFormController;
  formFields: IDynamicInput[];
  showSave = true;

  constructor( private toastrService: ToastrService ) {
  }

  $onInit() {
    this.initData();
  }

  submit() {
    this.socialForm.$setSubmitted();
    if ( this.socialForm.$invalid ) {
      this.toastrService.error('Please fill fields correctly', 'Validation Error');
      return;
    }
    this.onSave(new $Event(this.socials));
  }

  private initData() {
    this.formFields = [
      { label: 'LinkedIn', name: 'linkedin', placeholder: 'linkedin.com/example' },
      { label: 'Facebook', name: 'facebook', placeholder: 'facebook.com/example' },
      { label: 'Twitter', name: 'twitter', placeholder: 'twitter.com/example' },
      { label: 'Skype', name: 'skype', placeholder: 'skypename' }
    ];
  }
}

export const SocialFormComponent: IComponentOptions = {
  controller: SocialFormController,
  template: require('./social-form.component.html'),
  bindings: {
    socials: '<',
    showSave: '<?',
    onSave: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/social-form/social-form.component.ts